import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6db9c396&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=6db9c396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9c396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db9c396')) {
      api.createRecord('6db9c396', component.options)
    } else {
      api.reload('6db9c396', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6db9c396&scoped=true&", function () {
      api.rerender('6db9c396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/detail.vue"
export default component.exports